import React from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import SyntaxHighlighter from 'react-syntax-highlighter/prism';
import { prism } from 'react-syntax-highlighter/styles/prism';

import { P } from 'components';

const googlemapexample = `import React from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const CustomSkinMap = withScriptjs(withGoogleMap(props =>
    <GoogleMap
        defaultZoom={13}

        defaultCenter={{ lat: 40.748817, lng: -73.985428 }}
        defaultOptions={{
            scrollwheel: false,
            zoomControl: true,
            styles: [{"featureType":"water","stylers":[{"saturation":43},{"lightness":-11},{"hue":"#0088ff"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"hue":"#ff0000"},{"saturation":-100},{"lightness":99}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#808080"},{"lightness":54}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ece2d9"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#ccdca1"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#767676"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#b8cb93"}]},{"featureType":"poi.park","stylers":[{"visibility":"on"}]},{"featureType":"poi.sports_complex","stylers":[{"visibility":"on"}]},{"featureType":"poi.medical","stylers":[{"visibility":"on"}]},{"featureType":"poi.business","stylers":[{"visibility":"simplified"}]}] }}
    >
        <Marker
            position={{ lat: 40.748817, lng: -73.985428 }}
        />
    </GoogleMap>
));

class GoogleMaps extends React.Component{
    render(){
        return (
            <CustomSkinMap
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=YOUR_KEY_HERE"
                loadingElement={<div style={{ height: '100%'' }} />}
                containerElement={<div style={{ height: '100vh' }} />}
                mapElement={<div style={{ height: '100%' }} />}
            />
        );
    }
}

export default GoogleMaps;`;

const CustomSkinMap = withScriptjs(withGoogleMap(props =>
    <GoogleMap
        defaultZoom={13}

        defaultCenter={{ lat: 40.748817, lng: -73.985428 }}
        defaultOptions={{
            scrollwheel: false,
            zoomControl: true,
            styles: [{"featureType":"water","stylers":[{"saturation":43},{"lightness":-11},{"hue":"#0088ff"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"hue":"#ff0000"},{"saturation":-100},{"lightness":99}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#808080"},{"lightness":54}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ece2d9"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#ccdca1"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#767676"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#b8cb93"}]},{"featureType":"poi.park","stylers":[{"visibility":"on"}]},{"featureType":"poi.sports_complex","stylers":[{"visibility":"on"}]},{"featureType":"poi.medical","stylers":[{"visibility":"on"}]},{"featureType":"poi.business","stylers":[{"visibility":"simplified"}]}] }}
    >
        <Marker
            position={{ lat: 40.748817, lng: -73.985428 }}
        />
    </GoogleMap>
));

class GoogleMaps extends React.Component{
    render(){
        return (
            <div>
                <h1>Google Maps</h1>
                <P>We've used <a href="https://tomchentw.github.io/react-google-maps/" target="_blank" rel="noopener noreferrer">react-google-maps</a>. For props, please check the given link.</P>
                <CustomSkinMap
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBr-tgUtpm8cyjYVQDrjs8YpZH7zBNWPuY"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `100vh` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                />
                <SyntaxHighlighter language="jsx" style={prism}>{googlemapexample}</SyntaxHighlighter>
            </div>
        );
    }
}

export default GoogleMaps;



// WEBPACK FOOTER //
// ./src/containers/Documentation/Sections/GoogleMaps.jsx